import PropTypes from "prop-types";
import styled from "styled-components";
import { Rnd } from "react-rnd";

const ResizableShape = (props) => {
  const {
    aspectRatio,
    bg,
    shape,
    text,
    textStyles,
    resizeType,
    setFormData,
    attributes,
  } = props;

  const handleDragStop = (e, d) => {
    setFormData((prevState) => ({
      ...prevState,
      [resizeType]: {
        ...prevState[resizeType],
        x: d.x,
        y: d.y,
      },
    }));
  };

  const handleResize = (e, direction, ref, delta, position) => {
    setFormData((prevState) => ({
      ...prevState,
      [resizeType]: {
        ...prevState[resizeType],
        width: ref.offsetWidth,
        height: ref.offsetHeight,
        ...position,
      },
    }));
  };

  return (
    <RectContainer className="relative" bg={bg} circle={shape === "circle"}>
      <Rnd
        className={`bg-fadedBlack ${
          shape === "circle" ? "rounded-full" : "rounded-sm"
        }`}
        default={{
          x: attributes.x,
          y: attributes.y,
          width: attributes.width,
          height: attributes.height,
        }}
        size={{ width: attributes.width, height: attributes.height }}
        position={{ x: attributes.x, y: attributes.y }}
        onResize={handleResize}
        onDragStop={handleDragStop}
        minWidth={40}
        minHeight={40}
        bounds=".resive-boundary"
        lockAspectRatio={aspectRatio}
        resizeHandleClasses={{
          bottomLeft: "bg-black",
          bottomRight: "bg-black",
          topLeft: "bg-black",
          topRight: "bg-black",
        }}
      >
        {text && <Content style={textStyles}>{text}</Content>}
      </Rnd>
    </RectContainer>
  );
};

const RectContainer = styled.div`
  cursor: move;
  user-select: none;
  z-index: 40;

  & .rect {
    background: ${(props) => props.bg};
    border-color: black;
    border-radius: ${(props) => (props.circle ? "100" : "2")}%;

    .square {
      border-color: black;
      border-radius: ${(props) => (props.circle ? "2.5" : "1")}px;
      height: 10px;
      width: 10px;
    }
  }
`;

export const Content = styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-start;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: 4px;
  height: 100%;
  width: 100%;
`;

ResizableShape.defaultProps = {
  aspectRatio: 1,
  bg: "rgba(0,0,0,0.8)",
  defaultTop: 0,
  defaultLeft: 0,
  defaultHeight: 100,
  defaultWidth: 100,
  zoomable: "n, w, s, e, nw, ne, se, sw",
};

ResizableShape.propTypes = {
  aspectRatio: PropTypes.number,
  bg: PropTypes.string,
  shape: PropTypes.string,
  setFormData: PropTypes.func.isRequired,
  defaultTop: PropTypes.number,
  defaultLeft: PropTypes.number,
  defaultHeight: PropTypes.number,
  defaultWidth: PropTypes.number,
  text: PropTypes.string,
  zoomable: PropTypes.string,
  attributes: PropTypes.object.isRequired,
  resizeType: PropTypes.string.isRequired,
};

export default ResizableShape;
